import { TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  learnMoreLinkClick({ dataCenter }) {
    return {
      'Migrate To': dataCenter,
    };
  },
};

export default Transforms;
